
const firebaseConfig = {
    apiKey: process.env.REACT_APP_APIK_EY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGINGS_ENDER_ID,
    appId: process.env.REACT_APP_APP_ID

};

export default firebaseConfig;